const footprintClassNamesMap = {
  button: '.fp-button',
  input: '.fp-input',
  pinInput: '.fp-pin-input',
  label: '.fp-label',
  hint: '.fp-hint',
  linkButton: '.fp-link-button',
  link: 'a',
};

export default footprintClassNamesMap;
